import {
  EnhancedTableHeader,
  EnhancedTableHeaderType
} from '@components/table/widgets/shared-with-old';

export const comissionHeaders = (
  proposalPolicyCurrencySymbol?: string
): Record<string, EnhancedTableHeader> => ({
  businessPartner: {
    name: 'businessPartner',
    title: 'Business Partner',
    type: EnhancedTableHeaderType.Text
  },
  isPrimary: {
    name: 'isPrimary',
    title: 'Primary',
    type: EnhancedTableHeaderType.Text
  },
  policyBusinessPartnerType: {
    name: 'policyBusinessPartnerType',
    title: 'Type',
    type: EnhancedTableHeaderType.Text
  },
  overridenBusinessPartner: {
    name: 'overridenBusinessPartner',
    title: 'Overriden Business Partner',
    type: EnhancedTableHeaderType.Text
  },
  sharePercentage: {
    name: 'sharePercentage',
    title: 'Share',
    type: EnhancedTableHeaderType.RoundedPercentage
  },
  planCommissionAmount: {
    name: 'planCommissionAmount',
    title: 'Plan Commission',
    type: EnhancedTableHeaderType.Text
  },
  planCommissionApplicableOn: {
    name: 'planCommissionApplicableOn',
    title: 'Applicable On',
    type: EnhancedTableHeaderType.Text
  },
  commissionAmount: {
    name: 'commissionAmount',
    title: 'Commission',
    type: EnhancedTableHeaderType.RoundedCurrency,
    currency: proposalPolicyCurrencySymbol
  },
  policyShareCommissionAmount: {
    name: 'policyShareCommissionAmount',
    title: 'Policy Share Commission',
    type: EnhancedTableHeaderType.RoundedCurrency,
    currency: proposalPolicyCurrencySymbol
  },
  taxOnCommission: {
    name: 'taxOnCommission',
    title: 'Tax on Commission %',
    type: EnhancedTableHeaderType.RoundedPercentage
  },
  taxOnCommissionAmount: {
    name: 'taxOnCommissionAmount',
    title: 'Tax on Commission ',
    type: EnhancedTableHeaderType.RoundedCurrency,
    currency: proposalPolicyCurrencySymbol
  }
});
